module.exports = __webpack_public_path__ + "static/media/alertHeader.84b352e3.jpg";